import { render } from "./select.vue?vue&type=template&id=5e25d20c&scoped=true"
import script from "./select.vue?vue&type=script&lang=js"
export * from "./select.vue?vue&type=script&lang=js"

import "./select.vue?vue&type=style&index=0&id=5e25d20c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e25d20c"

export default script